const countries = [
  {
    test: 1,
    text: 'Afeganistão',
    value: 'AF',
    sigla3: 'AFG',
    codigo: '004',
  },
  {
    test: 2,
    text: 'África do Sul',
    value: 'ZA',
    sigla3: 'ZAF',
    codigo: '710',
  },
  {
    test: 3,
    text: 'Albânia',
    value: 'AL',
    sigla3: 'ALB',
    codigo: '008',
  },
  {
    test: 4,
    text: 'Alemanha',
    value: 'DE',
    sigla3: 'DEU',
    codigo: '276',
  },
  {
    test: 5,
    text: 'Andorra',
    value: 'AD',
    sigla3: 'AND',
    codigo: '020',
  },
  {
    test: 6,
    text: 'Angola',
    value: 'AO',
    sigla3: 'AGO',
    codigo: '024',
  },
  {
    test: 7,
    text: 'Anguilla',
    value: 'AI',
    sigla3: 'AIA',
    codigo: '660',
  },
  {
    test: 8,
    text: 'Antártida',
    value: 'AQ',
    sigla3: 'ATA',
    codigo: '010',
  },
  {
    test: 9,
    text: 'Antígua e Barbuda',
    value: 'AG',
    sigla3: 'ATG',
    codigo: '028',
  },
  {
    test: 10,
    text: 'Antilhas Holandesas',
    value: 'AN',
    sigla3: 'ANT',
    codigo: '530',
  },
  {
    test: 11,
    text: 'Arábia Saudita',
    value: 'SA',
    sigla3: 'SAU',
    codigo: '682',
  },
  {
    test: 12,
    text: 'Argélia',
    value: 'DZ',
    sigla3: 'DZA',
    codigo: '012',
  },
  {
    test: 13,
    text: 'Argentina',
    value: 'AR',
    sigla3: 'ARG',
    codigo: '032',
  },
  {
    test: 14,
    text: 'Armênia',
    value: 'AM',
    sigla3: 'ARM',
    codigo: '51',
  },
  {
    test: 15,
    text: 'Aruba',
    value: 'AW',
    sigla3: 'ABW',
    codigo: '533',
  },
  {
    test: 16,
    text: 'Austrália',
    value: 'AU',
    sigla3: 'AUS',
    codigo: '036',
  },
  {
    test: 17,
    text: 'Áustria',
    value: 'AT',
    sigla3: 'AUT',
    codigo: '040',
  },
  {
    test: 18,
    text: 'Azerbaijão',
    value: 'AZ  ',
    sigla3: 'AZE',
    codigo: '31',
  },
  {
    test: 19,
    text: 'Bahamas',
    value: 'BS',
    sigla3: 'BHS',
    codigo: '044',
  },
  {
    test: 20,
    text: 'Bahrein',
    value: 'BH',
    sigla3: 'BHR',
    codigo: '048',
  },
  {
    test: 21,
    text: 'Bangladesh',
    value: 'BD',
    sigla3: 'BGD',
    codigo: '050',
  },
  {
    test: 22,
    text: 'Barbados',
    value: 'BB',
    sigla3: 'BRB',
    codigo: '052',
  },
  {
    test: 23,
    text: 'Belarus',
    value: 'BY',
    sigla3: 'BLR',
    codigo: '112',
  },
  {
    test: 24,
    text: 'Bélgica',
    value: 'BE',
    sigla3: 'BEL',
    codigo: '056',
  },
  {
    test: 25,
    text: 'Belize',
    value: 'BZ',
    sigla3: 'BLZ',
    codigo: '084',
  },
  {
    test: 26,
    text: 'Benin',
    value: 'BJ',
    sigla3: 'BEN',
    codigo: '204',
  },
  {
    test: 27,
    text: 'Bermudas',
    value: 'BM',
    sigla3: 'BMU',
    codigo: '060',
  },
  {
    test: 28,
    text: 'Bolívia',
    value: 'BO',
    sigla3: 'BOL',
    codigo: '068',
  },
  {
    test: 29,
    text: 'Bósnia-Herzegóvina',
    value: 'BA',
    sigla3: 'BIH',
    codigo: '070',
  },
  {
    test: 30,
    text: 'Botsuana',
    value: 'BW',
    sigla3: 'BWA',
    codigo: '072',
  },
  {
    test: 32,
    text: 'Brunei',
    value: 'BN',
    sigla3: 'BRN',
    codigo: '096',
  },
  {
    test: 33,
    text: 'Bulgária',
    value: 'BG',
    sigla3: 'BGR',
    codigo: '100',
  },
  {
    test: 34,
    text: 'Burkina Fasso',
    value: 'BF',
    sigla3: 'BFA',
    codigo: '854',
  },
  {
    test: 35,
    text: 'Burundi',
    value: 'BI',
    sigla3: 'BDI',
    codigo: '108',
  },
  {
    test: 36,
    text: 'Butão',
    value: 'BT',
    sigla3: 'BTN',
    codigo: '064',
  },
  {
    test: 37,
    text: 'Cabo Verde',
    value: 'CV',
    sigla3: 'CPV',
    codigo: '132',
  },
  {
    test: 38,
    text: 'Camarões',
    value: 'CM',
    sigla3: 'CMR',
    codigo: '120',
  },
  {
    test: 39,
    text: 'Camboja',
    value: 'KH',
    sigla3: 'KHM',
    codigo: '116',
  },
  {
    test: 40,
    text: 'Canadá',
    value: 'CA',
    sigla3: 'CAN',
    codigo: '124',
  },
  {
    test: 41,
    text: 'Cazaquistão',
    value: 'KZ',
    sigla3: 'KAZ',
    codigo: '398',
  },
  {
    test: 42,
    text: 'Chade',
    value: 'TD',
    sigla3: 'TCD',
    codigo: '148',
  },
  {
    test: 43,
    text: 'Chile',
    value: 'CL',
    sigla3: 'CHL',
    codigo: '152',
  },
  {
    test: 44,
    text: 'China',
    value: 'CN',
    sigla3: 'CHN',
    codigo: '156',
  },
  {
    test: 45,
    text: 'Chipre',
    value: 'CY',
    sigla3: 'CYP',
    codigo: '196',
  },
  {
    test: 46,
    text: 'Cingapura',
    value: 'SG',
    sigla3: 'SGP',
    codigo: '702',
  },
  {
    test: 47,
    text: 'Colômbia',
    value: 'CO',
    sigla3: 'COL',
    codigo: '170',
  },
  {
    test: 48,
    text: 'Congo',
    value: 'CG',
    sigla3: 'COG',
    codigo: '178',
  },
  {
    test: 49,
    text: 'Coréia do Norte',
    value: 'KP',
    sigla3: 'PRK',
    codigo: '408',
  },
  {
    test: 50,
    text: 'Coréia do Sul',
    value: 'KR',
    sigla3: 'KOR',
    codigo: '410',
  },
  {
    test: 51,
    text: 'Costa do Marfim',
    value: 'CI',
    sigla3: 'CIV',
    codigo: '384',
  },
  {
    test: 52,
    text: 'Costa Rica',
    value: 'CR',
    sigla3: 'CRI',
    codigo: '188',
  },
  {
    test: 53,
    text: 'Croácia (Hrvatska)',
    value: 'HR',
    sigla3: 'HRV',
    codigo: '191',
  },
  {
    test: 54,
    text: 'Cuba',
    value: 'CU',
    sigla3: 'CUB',
    codigo: '192',
  },
  {
    test: 55,
    text: 'Dinamarca',
    value: 'DK',
    sigla3: 'DNK',
    codigo: '208',
  },
  {
    test: 56,
    text: 'Djibuti',
    value: 'DJ',
    sigla3: 'DJI',
    codigo: '262',
  },
  {
    test: 57,
    text: 'Dominica',
    value: 'DM',
    sigla3: 'DMA',
    codigo: '212',
  },
  {
    test: 58,
    text: 'Egito',
    value: 'EG',
    sigla3: 'EGY',
    codigo: '818',
  },
  {
    test: 59,
    text: 'El Salvador',
    value: 'SV',
    sigla3: 'SLV',
    codigo: '222',
  },
  {
    test: 60,
    text: 'Emirados Árabes Unidos',
    value: 'AE',
    sigla3: 'ARE',
    codigo: '784',
  },
  {
    test: 61,
    text: 'Equador',
    value: 'EC',
    sigla3: 'ECU',
    codigo: '218',
  },
  {
    test: 62,
    text: 'Eritréia',
    value: 'ER',
    sigla3: 'ERI',
    codigo: '232',
  },
  {
    test: 63,
    text: 'Eslováquia',
    value: 'SK',
    sigla3: 'SVK',
    codigo: '703',
  },
  {
    test: 64,
    text: 'Eslovênia',
    value: 'SI',
    sigla3: 'SVN',
    codigo: '705',
  },
  {
    test: 65,
    text: 'Espanha',
    value: 'ES',
    sigla3: 'ESP',
    codigo: '724',
  },
  {
    test: 66,
    text: 'Estados Unidos',
    value: 'US',
    sigla3: 'USA',
    codigo: '840',
  },
  {
    test: 67,
    text: 'Estônia',
    value: 'EE',
    sigla3: 'EST',
    codigo: '233',
  },
  {
    test: 68,
    text: 'Etiópia',
    value: 'ET',
    sigla3: 'ETH',
    codigo: '231',
  },
  {
    test: 69,
    text: 'Fiji',
    value: 'FJ',
    sigla3: 'FJI',
    codigo: '242',
  },
  {
    test: 70,
    text: 'Filipinas',
    value: 'PH',
    sigla3: 'PHL',
    codigo: '608',
  },
  {
    test: 71,
    text: 'Finlândia',
    value: 'FI',
    sigla3: 'FIN',
    codigo: '246',
  },
  {
    test: 72,
    text: 'França',
    value: 'FR',
    sigla3: 'FRA',
    codigo: '250',
  },
  {
    test: 73,
    text: 'Gabão',
    value: 'GA',
    sigla3: 'GAB',
    codigo: '266',
  },
  {
    test: 74,
    text: 'Gâmbia',
    value: 'GM',
    sigla3: 'GMB',
    codigo: '270',
  },
  {
    test: 75,
    text: 'Gana',
    value: 'GH',
    sigla3: 'GHA',
    codigo: '288',
  },
  {
    test: 76,
    text: 'Geórgia',
    value: 'GE',
    sigla3: 'GEO',
    codigo: '268',
  },
  {
    test: 77,
    text: 'Gibraltar',
    value: 'GI',
    sigla3: 'GIB',
    codigo: '292',
  },
  {
    test: 78,
    text: 'Grã-Bretanha (Reino Unido, UK)',
    value: 'GB',
    sigla3: 'GBR',
    codigo: '826',
  },
  {
    test: 79,
    text: 'Granada',
    value: 'GD',
    sigla3: 'GRD',
    codigo: '308',
  },
  {
    test: 80,
    text: 'Grécia',
    value: 'GR',
    sigla3: 'GRC',
    codigo: '300',
  },
  {
    test: 81,
    text: 'Groelândia',
    value: 'GL',
    sigla3: 'GRL',
    codigo: '304',
  },
  {
    test: 82,
    text: 'Guadalupe',
    value: 'GP',
    sigla3: 'GLP',
    codigo: '312',
  },
  {
    test: 83,
    text: 'Guam (Território dos Estados Unidos)',
    value: 'GU',
    sigla3: 'GUM',
    codigo: '316',
  },
  {
    test: 84,
    text: 'Guatemala',
    value: 'GT',
    sigla3: 'GTM',
    codigo: '320',
  },
  {
    test: 85,
    text: 'Guernsey',
    value: 'G',
    sigla3: 'GGY',
    codigo: '832',
  },
  {
    test: 86,
    text: 'Guiana',
    value: 'GY',
    sigla3: 'GUY',
    codigo: '328',
  },
  {
    test: 87,
    text: 'Guiana Francesa',
    value: 'GF',
    sigla3: 'GUF',
    codigo: '254',
  },
  {
    test: 88,
    text: 'Guiné',
    value: 'GN',
    sigla3: 'GIN',
    codigo: '324',
  },
  {
    test: 89,
    text: 'Guiné Equatorial',
    value: 'GQ',
    sigla3: 'GNQ',
    codigo: '226',
  },
  {
    test: 90,
    text: 'Guiné-Bissau',
    value: 'GW',
    sigla3: 'GNB',
    codigo: '624',
  },
  {
    test: 91,
    text: 'Haiti',
    value: 'HT',
    sigla3: 'HTI',
    codigo: '332',
  },
  {
    test: 92,
    text: 'Holanda',
    value: 'NL',
    sigla3: 'NLD',
    codigo: '528',
  },
  {
    test: 93,
    text: 'Honduras',
    value: 'HN',
    sigla3: 'HND',
    codigo: '340',
  },
  {
    test: 94,
    text: 'Hong Kong',
    value: 'HK',
    sigla3: 'HKG',
    codigo: '344',
  },
  {
    test: 95,
    text: 'Hungria',
    value: 'HU',
    sigla3: 'HUN',
    codigo: '348',
  },
  {
    test: 96,
    text: 'Iêmen',
    value: 'YE',
    sigla3: 'YEM',
    codigo: '887',
  },
  {
    test: 97,
    text: 'Ilha Bouvet (Território da Noruega)',
    value: 'BV',
    sigla3: 'BVT',
    codigo: '074',
  },
  {
    test: 98,
    text: 'Ilha do Homem',
    value: 'IM',
    sigla3: 'IMN',
    codigo: '833',
  },
  {
    test: 99,
    text: 'Ilha Natal',
    value: 'CX',
    sigla3: 'CXR',
    codigo: '162',
  },
  {
    test: 100,
    text: 'Ilha Pitcairn',
    value: 'PN',
    sigla3: 'PCN',
    codigo: '612',
  },
  {
    test: 101,
    text: 'Ilha Reunião',
    value: 'RE',
    sigla3: 'REU',
    codigo: '638',
  },
  {
    test: 102,
    text: 'Ilhas Aland',
    value: 'AX',
    sigla3: 'ALA',
    codigo: '248',
  },
  {
    test: 103,
    text: 'Ilhas Cayman',
    value: 'KY',
    sigla3: 'CYM',
    codigo: '136',
  },
  {
    test: 104,
    text: 'Ilhas Cocos',
    value: 'CC',
    sigla3: 'CCK',
    codigo: '166',
  },
  {
    test: 105,
    text: 'Ilhas Comores',
    value: 'KM',
    sigla3: 'COM',
    codigo: '174',
  },
  {
    test: 106,
    text: 'Ilhas Cook',
    value: 'CK',
    sigla3: 'COK',
    codigo: '184',
  },
  {
    test: 107,
    text: 'Ilhas Faroes',
    value: 'FO',
    sigla3: 'FRO',
    codigo: '234',
  },
  {
    test: 108,
    text: 'Ilhas Falkland (Malvinas)',
    value: 'FK',
    sigla3: 'FLK',
    codigo: '238',
  },
  {
    test: 109,
    text: 'Ilhas Geórgia do Sul e Sandwich do Sul',
    value: 'GS',
    sigla3: 'SGS',
    codigo: '239',
  },
  {
    test: 110,
    text: 'Ilhas Heard e McDonald (Território da Austrália)',
    value: 'HM',
    sigla3: 'HMD',
    codigo: '334',
  },
  {
    test: 111,
    text: 'Ilhas Marianas do Norte',
    value: 'MP',
    sigla3: 'MNP',
    codigo: '580',
  },
  {
    test: 112,
    text: 'Ilhas Marshall',
    value: 'MH',
    sigla3: 'MHL',
    codigo: '584',
  },
  {
    test: 113,
    text: 'Ilhas Menores dos Estados Unidos',
    value: 'UM',
    sigla3: 'UMI',
    codigo: '581',
  },
  {
    test: 114,
    text: 'Ilhas Norfolk',
    value: 'NF',
    sigla3: 'NFK',
    codigo: '574',
  },
  {
    test: 115,
    text: 'Ilhas Seychelles',
    value: 'SC',
    sigla3: 'SYC',
    codigo: '690',
  },
  {
    test: 116,
    text: 'Ilhas Solomão',
    value: 'SB',
    sigla3: 'SLB',
    codigo: '090',
  },
  {
    test: 117,
    text: 'Ilhas Svalbard e Jan Mayen',
    value: 'SJ',
    sigla3: 'SJM',
    codigo: '744',
  },
  {
    test: 118,
    text: 'Ilhas Tokelau',
    value: 'TK',
    sigla3: 'TKL',
    codigo: '772',
  },
  {
    test: 119,
    text: 'Ilhas Turks e Caicos',
    value: 'TC',
    sigla3: 'TCA',
    codigo: '796',
  },
  {
    test: 120,
    text: 'Ilhas Virgens (Estados Unidos)',
    value: 'VI',
    sigla3: 'VIR',
    codigo: '850',
  },
  {
    test: 121,
    text: 'Ilhas Virgens (Inglaterra)',
    value: 'VG',
    sigla3: 'VGB',
    codigo: '092',
  },
  {
    test: 122,
    text: 'Ilhas Wallis e Futuna',
    value: 'WF',
    sigla3: 'WLF',
    codigo: '876',
  },
  {
    test: 123,
    text: 'índia',
    value: 'IN',
    sigla3: 'IND',
    codigo: '356',
  },
  {
    test: 124,
    text: 'Indonésia',
    value: 'ID',
    sigla3: 'IDN',
    codigo: '360',
  },
  {
    test: 125,
    text: 'Irã',
    value: 'IR',
    sigla3: 'IRN',
    codigo: '364',
  },
  {
    test: 126,
    text: 'Iraque',
    value: 'IQ',
    sigla3: 'IRQ',
    codigo: '368',
  },
  {
    test: 127,
    text: 'Irlanda',
    value: 'IE',
    sigla3: 'IRL',
    codigo: '372',
  },
  {
    test: 128,
    text: 'Islândia',
    value: 'IS',
    sigla3: 'ISL',
    codigo: '352',
  },
  {
    test: 129,
    text: 'Israel',
    value: 'IL',
    sigla3: 'ISR',
    codigo: '376',
  },
  {
    test: 130,
    text: 'Itália',
    value: 'IT',
    sigla3: 'ITA',
    codigo: '380',
  },
  {
    test: 131,
    text: 'Jamaica',
    value: 'JM',
    sigla3: 'JAM',
    codigo: '388',
  },
  {
    test: 132,
    text: 'Japão',
    value: 'JP',
    sigla3: 'JPN',
    codigo: '392',
  },
  {
    test: 133,
    text: 'Jersey',
    value: 'JE',
    sigla3: 'JEY',
    codigo: '832',
  },
  {
    test: 134,
    text: 'Jordânia',
    value: 'JO',
    sigla3: 'JOR',
    codigo: '400',
  },
  {
    test: 135,
    text: 'Kênia',
    value: 'KE',
    sigla3: 'KEN',
    codigo: '404',
  },
  {
    test: 136,
    text: 'Kiribati',
    value: 'KI',
    sigla3: 'KIR',
    codigo: '296',
  },
  {
    test: 137,
    text: 'Kuait',
    value: 'KW',
    sigla3: 'KWT',
    codigo: '414',
  },
  {
    test: 138,
    text: 'Laos',
    value: 'LA',
    sigla3: 'LAO',
    codigo: '418',
  },
  {
    test: 139,
    text: 'Látvia',
    value: 'LV',
    sigla3: 'LVA',
    codigo: '428',
  },
  {
    test: 140,
    text: 'Lesoto',
    value: 'LS',
    sigla3: 'LSO',
    codigo: '426',
  },
  {
    test: 141,
    text: 'Líbano',
    value: 'LB',
    sigla3: 'LBN',
    codigo: '422',
  },
  {
    test: 142,
    text: 'Libéria',
    value: 'LR',
    sigla3: 'LBR',
    codigo: '430',
  },
  {
    test: 143,
    text: 'Líbia',
    value: 'LY',
    sigla3: 'LBY',
    codigo: '434',
  },
  {
    test: 144,
    text: 'Liechtenstein',
    value: 'LI',
    sigla3: 'LIE',
    codigo: '438',
  },
  {
    test: 145,
    text: 'Lituânia',
    value: 'LT',
    sigla3: 'LTU',
    codigo: '440',
  },
  {
    test: 146,
    text: 'Luxemburgo',
    value: 'LU',
    sigla3: 'LUX',
    codigo: '442',
  },
  {
    test: 147,
    text: 'Macau',
    value: 'MO',
    sigla3: 'MAC',
    codigo: '446',
  },
  {
    test: 148,
    text: 'Macedônia (República Yugoslava)',
    value: 'MK',
    sigla3: 'MKD',
    codigo: '807',
  },
  {
    test: 149,
    text: 'Madagascar',
    value: 'MG',
    sigla3: 'MDG',
    codigo: '450',
  },
  {
    test: 150,
    text: 'Malásia',
    value: 'MY',
    sigla3: 'MYS',
    codigo: '458',
  },
  {
    test: 151,
    text: 'Malaui',
    value: 'MW',
    sigla3: 'MWI',
    codigo: '454',
  },
  {
    test: 152,
    text: 'Maldivas',
    value: 'MV',
    sigla3: 'MDV',
    codigo: '462',
  },
  {
    test: 153,
    text: 'Mali',
    value: 'ML',
    sigla3: 'MLI',
    codigo: '466',
  },
  {
    test: 154,
    text: 'Malta',
    value: 'MT',
    sigla3: 'MLT',
    codigo: '470',
  },
  {
    test: 155,
    text: 'Marrocos',
    value: 'MA',
    sigla3: 'MAR',
    codigo: '504',
  },
  {
    test: 156,
    text: 'Martinica',
    value: 'MQ',
    sigla3: 'MTQ',
    codigo: '474',
  },
  {
    test: 157,
    text: 'Maurício',
    value: 'MU',
    sigla3: 'MUS',
    codigo: '480',
  },
  {
    test: 158,
    text: 'Mauritânia',
    value: 'MR',
    sigla3: 'MRT',
    codigo: '478',
  },
  {
    test: 159,
    text: 'Mayotte',
    value: 'YT',
    sigla3: 'MYT',
    codigo: '175',
  },
  {
    test: 160,
    text: 'México',
    value: 'MX',
    sigla3: 'MEX',
    codigo: '484',
  },
  {
    test: 161,
    text: 'Micronésia',
    value: 'FM',
    sigla3: 'FSM',
    codigo: '583',
  },
  {
    test: 162,
    text: 'Moçambique',
    value: 'MZ',
    sigla3: 'MOZ',
    codigo: '508',
  },
  {
    test: 163,
    text: 'Moldova',
    value: 'MD',
    sigla3: 'MDA',
    codigo: '498',
  },
  {
    test: 164,
    text: 'Mônaco',
    value: 'MC',
    sigla3: 'MCO',
    codigo: '492',
  },
  {
    test: 165,
    text: 'Mongólia',
    value: 'MN',
    sigla3: 'MNG',
    codigo: '496',
  },
  {
    test: 166,
    text: 'Montenegro',
    value: 'ME',
    sigla3: 'MNE',
    codigo: '499',
  },
  {
    test: 167,
    text: 'Montserrat',
    value: 'MS',
    sigla3: 'MSR',
    codigo: '500',
  },
  {
    test: 168,
    text: 'Myanma',
    value: 'MM',
    sigla3: 'MMR',
    codigo: '104',
  },
  {
    test: 169,
    text: 'Namíbia',
    value: 'NA',
    sigla3: 'NAM',
    codigo: '516',
  },
  {
    test: 170,
    text: 'Nauru',
    value: 'NR',
    sigla3: 'NRU',
    codigo: '520',
  },
  {
    test: 171,
    text: 'Nepal',
    value: 'NP',
    sigla3: 'NPL',
    codigo: '524',
  },
  {
    test: 172,
    text: 'Nicarágua',
    value: 'NI',
    sigla3: 'NIC',
    codigo: '558',
  },
  {
    test: 173,
    text: 'Níger',
    value: 'NE',
    sigla3: 'NER',
    codigo: '562',
  },
  {
    test: 174,
    text: 'Nigéria',
    value: 'NG',
    sigla3: 'NGA',
    codigo: '566',
  },
  {
    test: 175,
    text: 'Niue',
    value: 'NU',
    sigla3: 'NIU',
    codigo: '570',
  },
  {
    test: 176,
    text: 'Noruega',
    value: 'NO',
    sigla3: 'NOR',
    codigo: '578',
  },
  {
    test: 177,
    text: 'Nova Caledônia',
    value: 'NC',
    sigla3: 'NCL',
    codigo: '540',
  },
  {
    test: 178,
    text: 'Nova Zelândia',
    value: 'NZ',
    sigla3: 'NZL',
    codigo: '554',
  },
  {
    test: 179,
    text: 'Omã',
    value: 'OM',
    sigla3: 'OMN',
    codigo: '512',
  },
  {
    test: 180,
    text: 'Palau',
    value: 'PW',
    sigla3: 'PLW',
    codigo: '585',
  },
  {
    test: 181,
    text: 'Panamá',
    value: 'PA',
    sigla3: 'PAN',
    codigo: '591',
  },
  {
    test: 182,
    text: 'Papua-Nova Guiné',
    value: 'PG',
    sigla3: 'PNG',
    codigo: '598',
  },
  {
    test: 183,
    text: 'Paquistão',
    value: 'PK',
    sigla3: 'PAK',
    codigo: '586',
  },
  {
    test: 184,
    text: 'Paraguai',
    value: 'PY',
    sigla3: 'PRY',
    codigo: '600',
  },
  {
    test: 185,
    text: 'Peru',
    value: 'PE',
    sigla3: 'PER',
    codigo: '604',
  },
  {
    test: 186,
    text: 'Polinésia Francesa',
    value: 'PF',
    sigla3: 'PYF',
    codigo: '258',
  },
  {
    test: 187,
    text: 'Polônia',
    value: 'PL',
    sigla3: 'POL',
    codigo: '616',
  },
  {
    test: 188,
    text: 'Porto Rico',
    value: 'PR',
    sigla3: 'PRI',
    codigo: '630',
  },
  {
    test: 189,
    text: 'Portugal',
    value: 'PT',
    sigla3: 'PRT',
    codigo: '620',
  },
  {
    test: 190,
    text: 'Qatar',
    value: 'QA',
    sigla3: 'QAT',
    codigo: '634',
  },
  {
    test: 191,
    text: 'Quirguistão',
    value: 'KG',
    sigla3: 'KGZ',
    codigo: '417',
  },
  {
    test: 192,
    text: 'República Centro-Africana',
    value: 'CF',
    sigla3: 'CAF',
    codigo: '140',
  },
  {
    test: 193,
    text: 'República Democrática do Congo',
    value: 'CD',
    sigla3: 'COD',
    codigo: '180',
  },
  {
    test: 194,
    text: 'República Dominicana',
    value: 'DO',
    sigla3: 'DOM',
    codigo: '214',
  },
  {
    test: 195,
    text: 'República Tcheca',
    value: 'CZ',
    sigla3: 'CZE',
    codigo: '203',
  },
  {
    test: 196,
    text: 'Romênia',
    value: 'RO',
    sigla3: 'ROM',
    codigo: '642',
  },
  {
    test: 197,
    text: 'Ruanda',
    value: 'RW',
    sigla3: 'RWA',
    codigo: '646',
  },
  {
    test: 198,
    text: 'Rússia (antiga URSS) - Federação Russa',
    value: 'RU',
    sigla3: 'RUS',
    codigo: '643',
  },
  {
    test: 199,
    text: 'Saara Ocidental',
    value: 'EH',
    sigla3: 'ESH',
    codigo: '732',
  },
  {
    test: 200,
    text: 'Saint Vincente e Granadinas',
    value: 'VC',
    sigla3: 'VCT',
    codigo: '670',
  },
  {
    test: 201,
    text: 'Samoa Americana',
    value: 'AS',
    sigla3: 'ASM',
    codigo: '016',
  },
  {
    test: 202,
    text: 'Samoa Ocidental',
    value: 'WS',
    sigla3: 'WSM',
    codigo: '882',
  },
  {
    test: 203,
    text: 'San Marino',
    value: 'SM',
    sigla3: 'SMR',
    codigo: '674',
  },
  {
    test: 204,
    text: 'Santa Helena',
    value: 'SH',
    sigla3: 'SHN',
    codigo: '654',
  },
  {
    test: 205,
    text: 'Santa Lúcia',
    value: 'LC',
    sigla3: 'LCA',
    codigo: '662',
  },
  {
    test: 206,
    text: 'São Bartolomeu',
    value: 'BL',
    sigla3: 'BLM',
    codigo: '652',
  },
  {
    test: 207,
    text: 'São Cristóvão e Névis',
    value: 'KN',
    sigla3: 'KNA',
    codigo: '659',
  },
  {
    test: 208,
    text: 'São Martim',
    value: 'MF',
    sigla3: 'MAF',
    codigo: '663',
  },
  {
    test: 209,
    text: 'São Tomé e Príncipe',
    value: 'ST',
    sigla3: 'STP',
    codigo: '678',
  },
  {
    test: 210,
    text: 'Senegal',
    value: 'SN',
    sigla3: 'SEN',
    codigo: '686',
  },
  {
    test: 211,
    text: 'Serra Leoa',
    value: 'SL',
    sigla3: 'SLE',
    codigo: '694',
  },
  {
    test: 212,
    text: 'Sérvia',
    value: 'RS',
    sigla3: 'SRB',
    codigo: '688',
  },
  {
    test: 213,
    text: 'Síria',
    value: 'SY',
    sigla3: 'SYR',
    codigo: '760',
  },
  {
    test: 214,
    text: 'Somália',
    value: 'SO',
    sigla3: 'SOM',
    codigo: '706',
  },
  {
    test: 215,
    text: 'Sri Lanka',
    value: 'LK',
    sigla3: 'LKA',
    codigo: '144',
  },
  {
    test: 216,
    text: 'St. Pierre and Miquelon',
    value: 'PM',
    sigla3: 'SPM',
    codigo: '666',
  },
  {
    test: 217,
    text: 'Suazilândia',
    value: 'SZ',
    sigla3: 'SWZ',
    codigo: '748',
  },
  {
    test: 218,
    text: 'Sudão',
    value: 'SD',
    sigla3: 'SDN',
    codigo: '736',
  },
  {
    test: 219,
    text: 'Suécia',
    value: 'SE',
    sigla3: 'SWE',
    codigo: '752',
  },
  {
    test: 220,
    text: 'Suíça',
    value: 'CH',
    sigla3: 'CHE',
    codigo: '756',
  },
  {
    test: 221,
    text: 'Suriname',
    value: 'SR',
    sigla3: 'SUR',
    codigo: '740',
  },
  {
    test: 222,
    text: 'Tadjiquistão',
    value: 'TJ',
    sigla3: 'TJK',
    codigo: '762',
  },
  {
    test: 223,
    text: 'Tailândia',
    value: 'TH',
    sigla3: 'THA',
    codigo: '764',
  },
  {
    test: 224,
    text: 'Taiwan',
    value: 'TW',
    sigla3: 'TWN',
    codigo: '158',
  },
  {
    test: 225,
    text: 'Tanzânia',
    value: 'TZ',
    sigla3: 'TZA',
    codigo: '834',
  },
  {
    test: 226,
    text: 'Território Britânico do Oceano índico',
    value: 'IO',
    sigla3: 'IOT',
    codigo: '086',
  },
  {
    test: 227,
    text: 'Territórios do Sul da França',
    value: 'TF',
    sigla3: 'ATF',
    codigo: '260',
  },
  {
    test: 228,
    text: 'Territórios Palestinos Ocupados',
    value: 'PS',
    sigla3: 'PSE',
    codigo: '275',
  },
  {
    test: 229,
    text: 'Timor Leste',
    value: 'TP',
    sigla3: 'TMP',
    codigo: '626',
  },
  {
    test: 230,
    text: 'Togo',
    value: 'TG',
    sigla3: 'TGO',
    codigo: '768',
  },
  {
    test: 231,
    text: 'Tonga',
    value: 'TO',
    sigla3: 'TON',
    codigo: '776',
  },
  {
    test: 232,
    text: 'Trinidad and Tobago',
    value: 'TT',
    sigla3: 'TTO',
    codigo: '780',
  },
  {
    test: 233,
    text: 'Tunísia',
    value: 'TN',
    sigla3: 'TUN',
    codigo: '788',
  },
  {
    test: 234,
    text: 'Turcomenistão',
    value: 'TM',
    sigla3: 'TKM',
    codigo: '795',
  },
  {
    test: 235,
    text: 'Turquia',
    value: 'TR',
    sigla3: 'TUR',
    codigo: '792',
  },
  {
    test: 236,
    text: 'Tuvalu',
    value: 'TV',
    sigla3: 'TUV',
    codigo: '798',
  },
  {
    test: 237,
    text: 'Ucrânia',
    value: 'UA',
    sigla3: 'UKR',
    codigo: '804',
  },
  {
    test: 238,
    text: 'Uganda',
    value: 'UG',
    sigla3: 'UGA',
    codigo: '800',
  },
  {
    test: 239,
    text: 'Uruguai',
    value: 'UY',
    sigla3: 'URY',
    codigo: '858',
  },
  {
    test: 240,
    text: 'Uzbequistão',
    value: 'UZ',
    sigla3: 'UZB',
    codigo: '860',
  },
  {
    test: 241,
    text: 'Vanuatu',
    value: 'VU',
    sigla3: 'VUT',
    codigo: '548',
  },
  {
    test: 242,
    text: 'Vaticano',
    value: 'VA',
    sigla3: 'VAT',
    codigo: '336',
  },
  {
    test: 243,
    text: 'Venezuela',
    value: 'VE',
    sigla3: 'VEN',
    codigo: '862',
  },
  {
    test: 244,
    text: 'Vietnã',
    value: 'VN',
    sigla3: 'VNM',
    codigo: '704',
  },
  {
    test: 245,
    text: 'Zâmbia',
    value: 'ZM',
    sigla3: 'ZMB',
    codigo: '894',
  },
  {
    test: 246,
    text: 'Zimbábue',
    value: 'ZW',
    sigla3: 'ZWE',
    codigo: '716',
  },
]
export default countries
